import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify/index'
import i18n from './plugins/i18n'
import router from './core/router'
import store from './core/store'
import Vuelidate from 'vuelidate'
import VueSweetalert2 from 'vue-sweetalert2'
import filters from '@/core/filters'
import VCurrencyField from 'v-currency-field'
import { VTextField } from 'vuetify/lib'  //Globally import VTextField
import './registerServiceWorker'
import * as VueGoogleMaps from 'vue2-google-maps'
import VCalendar from 'v-calendar'


Vue.component('v-text-field', VTextField)
Vue.use(VCurrencyField, {
	locale: 'pt-BR',
	decimalLength: 2,
	autoDecimalMode: true,
	min: null,
	max: null,
	defaultValue: 0,
  valueAsInteger: false,
  allowNegative: true
})

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyA5Vd8pS2TQajQwq35BaHiWGxn5t6pqWK8',
    libraries: 'places,drawing'
  },
})

Vue.use(VCalendar, {
  componentPrefix: 'vc',
})

import 'sweetalert2/dist/sweetalert2.min.css';
import 'animate.css'

const options = {
  customClass: {
    container: 'container-popup',
    confirmButton: 'br-btn',
    cancelButton: 'br-btn br-btn-cancelar bt-btn-cancelar-popup'
  },
  showClass: {
    popup: 'animated zoomIn'
  },
  hideClass: {
    popup: 'animated zoomOut'
  },
  showCloseButton: true
} 

// add validation system
Vue.use(Vuelidate)

Vue.use(VueSweetalert2, options)

// adiciona filtros personalizados
Vue.use(filters)

Vue.config.productionTip = false
Vue.config.language = 'pt_BR'

new Vue({
  i18n,
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
